var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-headline" }, [_vm._v("Partners")]),
    !_vm.isEnabled
      ? _c("div", [
          _c("p", { staticClass: "partner-row-disabled" }, [
            _vm._v(
              "This feature is not enabled for this distribution's package."
            )
          ])
        ])
      : _c(
          "div",
          [
            _c("p", { staticClass: "partner-row-hint" }, [
              _vm._v(
                "Configure up to 6 partner feeds shown in the partner row."
              )
            ]),
            _vm._l(_vm.localPartners, function(partnerId, index) {
              return _c(
                "div",
                { key: index, staticClass: "partner-row-item" },
                [
                  _c(
                    "md-input-container",
                    {
                      staticClass: "partner-select-container",
                      class: {
                        "md-input-invalid":
                          _vm.formSubmitted && !_vm.localPartners[index]
                      }
                    },
                    [
                      _c("label", [_vm._v("Partner " + _vm._s(index + 1))]),
                      _c(
                        "md-select",
                        {
                          attrs: {
                            value: _vm.localPartners[index],
                            name: "partner-" + index
                          },
                          on: {
                            input: function($event) {
                              return _vm.onSelectPartner(index, $event)
                            }
                          }
                        },
                        _vm._l(_vm.optionsFor(index), function(dist) {
                          return _c(
                            "md-option",
                            { key: dist._id, attrs: { value: dist._id } },
                            [_vm._v(_vm._s(dist.name))]
                          )
                        }),
                        1
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.formSubmitted && !_vm.localPartners[index],
                              expression:
                                "formSubmitted && !localPartners[index]"
                            }
                          ],
                          staticClass: "md-error"
                        },
                        [_vm._v("This field is required")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button md-warn",
                      attrs: { title: "Remove" },
                      on: {
                        click: function($event) {
                          return _vm.removePartner(index)
                        }
                      }
                    },
                    [
                      _c("md-icon", {
                        attrs: { "md-iconset": "fa fa-trash-alt" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _vm.localPartners.length < 6
              ? _c(
                  "md-button",
                  { staticClass: "md-raised", on: { click: _vm.addPartner } },
                  [
                    _c("md-icon", { attrs: { "md-iconset": "fa fa-plus" } }),
                    _vm._v("Add Partner")
                  ],
                  1
                )
              : _vm._e(),
            _c("p", { staticClass: "partner-row-count" }, [
              _vm._v(
                _vm._s(_vm.localPartners.length) + " / 6 partners configured"
              )
            ])
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f50bd17", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f50bd17","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/PartnerRowForm.vue
// module id = 827
// module chunks = 0